import TwoD_Materials from '../../assets/track_icons/2D_Materials.png';
import Biopolymer from '../../assets/track_icons/biopolymer.png';
import Environmental_Nanotechnology from '../../assets/track_icons/Environmental_Nanotechnology.png';
import Nano_Biotechnology from '../../assets/track_icons/Nano_Biotechnology.png';
import Nanofabrications from '../../assets/track_icons/Nanofabrications.png';
import Nanophotonics from '../../assets/track_icons/Nanophotonics.png';
import Smart_Materials from '../../assets/track_icons/Smart_Materials.png';
import Agri_Nanotechnology from '../../assets/track_icons/Agri_Nanotechnology.png';
import Computational_Nanotechnology from '../../assets/track_icons/Computational_Nanotechnology.png';
import Graphene_Technologies from '../../assets/track_icons/Graphene_Technologies.png';
import Nanodevices_and_Nano_Sensors from '../../assets/track_icons/Nanodevices_&_Nano_Sensors.png';
import Nanomagnetics from '../../assets/track_icons/Nanomagnetics.png';
import Nanophysics_and_Nanochemistry from '../../assets/track_icons/Nanophysics_&_Nanochemistry.png';
import Structural_Materials from '../../assets/track_icons/Structural_Materials.png';
import AI_in_Nanotechnology from '../../assets/track_icons/AI_in_Nanotechnology.png';
import Drug_Delivery_Systems from '../../assets/track_icons/Drug_Delivery_Systems.png';
import Materials_Science from '../../assets/track_icons/Materials_Science.png';
import Nanoelectronics from '../../assets/track_icons/Nanoelectronics.png';
import Nanomedicine from '../../assets/track_icons/nanomedicine.png';
import Pharmaceutical_Nanotechnology from '../../assets/track_icons/pharmaceutical_nanotechnology.png';

export const tracks = [
  { name: "2D Materials", icon: TwoD_Materials },
  { name: "Biopolymer", icon: Biopolymer },
  { name: "Environmental Nanotechnology", icon: Environmental_Nanotechnology },
  { name: "Nano Biotechnology", icon: Nano_Biotechnology },
  { name: "Nanofabrications", icon: Nanofabrications },
  { name: "Nanophotonics", icon: Nanophotonics },
  { name: "Smart Materials", icon: Smart_Materials },
  { name: "Agri Nanotechnology", icon: Agri_Nanotechnology },
  { name: "Computational Nanotechnology", icon: Computational_Nanotechnology },
  { name: "Graphene Technologies", icon: Graphene_Technologies },
  { name: "Nanodevices & Nano Sensors", icon: Nanodevices_and_Nano_Sensors },
  { name: "Nanomagnetics", icon: Nanomagnetics },
  { name: "Nanophysics & Nanochemistry", icon: Nanophysics_and_Nanochemistry },
  { name: "Structural Materials", icon: Structural_Materials },
  { name: "AI in Nanotechnology", icon: AI_in_Nanotechnology },
  { name: "Drug Delivery Systems", icon: Drug_Delivery_Systems },
  { name: "Materials Science", icon: Materials_Science },
  { name: "Nanoelectronics", icon: Nanoelectronics },
  { name: "Nanomedicine", icon: Nanomedicine },
  { name: "Pharmaceutical Nanotechnology", icon: Pharmaceutical_Nanotechnology },
];
